const URLactual = window.location.href;
let result;
if(URLactual=='http://basic.bodeganet.cl/' || 
    URLactual=='https://basic.bodeganet.cl/' || 
    URLactual=='http://www.basic.bodeganet.cl/' ||
    URLactual=='https://www.basic.bodeganet.cl/'){
    result=true
} else {
    result=false
};
export default result